import * as React from 'react';

class Verein extends React.Component {

    public render() {
        return (
            <div>
                Verein
            </div>
        );
    }
}

export default Verein;



// WEBPACK FOOTER //
// ./src/Verein/Verein.tsx